<template>
  <svg :width="width" :height="height" viewBox="0 0 247 128" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.04883 18.1296C12.3699 71.6416 167.142 159.291 242.586 55.957C201.597 3.67523 72.4666 -53.834 4.04883 124.232"
      stroke="currentColor"
      stroke-width="7"
      stroke-linecap="round"
    />
  </svg>
</template>
<script setup lang="ts">
defineProps({
  width: {
    type: String,
    default: '247',
  },
  height: {
    type: String,
    default: '128',
  },
})
</script>
